/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { FC } from 'react'
import LayoutDefault from '@/components/layouts/Layout'
import SectionHeaderService from '@/components/modules/SectionHeaderService'
import TitleShadow from '@/components/modules/TitleShadow'
import Benefit from '@/components/modules/Benefit'
import ListBullet from '@/components/modules/ListBullet'
import ServiceItem from '@/components/modules/ServiceItem'
import PortfolioItem from '@/components/modules/PortfolioItem'
import WarrantyItem from '@/components/modules/WarrantyItem'
import ServiceGetInTouch from '@/components/modules/ServiceGetInTouch'
import Button from '@/components/elements/Button'
import ImgResponsive from '@/components/elements/ImgResponsive'
import Router from 'next/router'
import { FaArrowRight } from 'react-icons/fa'
import Link from 'next/link'

const ServicePage: FC = () => {
  return (
    <LayoutDefault>
      <SectionHeaderService
        bgColors='#00BE00'
        bgImage='/images/service/Twin_Service_line_app.webp'
        bgImageMd='/images/service/Twin_Service_line_app.webp'
        bgImageSm='/images/service/Twin_Service_line_app.webp'
        title={
          <>&quot;เพิ่มศักยภาพบนโลกออนไลน์ให้ธุรกิจ สร้างความใกล้ชิดกับลูกค้าด้วย LINE OA&quot;</>
        }
        description='"Enhance your online Potential, Foster Customer connections with LINE OA."'
        bgImageWidth={1214}
        bgImageHeight={534}
        btnText='ปรึกษาเรื่องการพัฒนาเว็บไซต์'
        onClick={() => Router.push('/contact-service')}
        prologue='สำหรับนักพัฒนา'
        colorPrologue='rgba(0,0,0,.08)'
        titleShadow='LiFF'
        colorTitleShadow='#000000'
        align='center'
        content={
          <>
            <p className='text-center'>
              LiFF (Line Front-end Framework) คือแพลตฟอร์มสำหรับนักพัฒนาของบริษัท ไลน์ ที่ทำการผสาน
              Line Official Account ของคุณเข้ากับ Web application ของธุรกิจคุณ
              เพื่อให้ลูกค้าของคุณสามารถใช้บริการหรือทำกิจกรรมใด ๆ ที่มีบน Web Application
              ของคุณผ่านแอปพลิเคชั่น LINE ได้เลยโดยไม่ต้องออกจากแอป LINE
              เพื่อความสะดวกและความราบรื่นในการใช้งาน
            </p>
            <p className='text-center'>
              ปัจจุบัน LINE OA มีความสำคัญต่อธุรกิจหลาย ๆ ธุรกิจ
              ในการติดต่อสื่อสารและสร้างความสัมพันธ์อันดีต่อลูกค้า
              นับว่าเป็นหนึ่งเครื่องมือที่สำคัญในการทำ CRM (Customer Relationship Management)
              ให้กับธุรกิจ ดังนั้น LiFF
              จึงเข้ามาเติมเต็มให้ลูกค้าสามารถเข้าถึงเนื้อหาและการให้บริการทุก ๆ
              บริการของคุณได้ง่ายขึ้น
            </p>
            <p className='text-center'>
              การพัฒนา LiFF (LiFF Development) ทีมพัฒนาของเรามีความรู้เรื่องและความชำนาญในการพัฒนา
              LiFF เป็นอย่างดี สามารถสร้างสรรค์รูปแบบการแสดง เนื้อหาและการทำงานบน LINE OA
              ได้อย่างเหมาะสม ที่สำคัญทีมพัฒนาของเรามีความเชี่ยวชาญในการพัฒนา Web Application
              ด้วยเทคโนโลยีชั้นสูงอย่าง JavaScript เป็นอย่างดี
              อีกทั้งมุ่งเน้นในการให้บริการและการดูแลหลังการขายไปจนกว่าจะมั่นใจว่าผลงานของเราสามารถใช้งานได้อย่างมีประสิทธิภาพและลูกค้ามีความพึงพอใจในบริการของเรา
            </p>
            <div className='text-center'>
              <Button
                htmlType='button'
                className='btn-neutral'
                onClick={() => Router.push('/contact-service')}
              >
                สอบถามข้อมูลเพิ่มเติม
              </Button>
            </div>
          </>
        }
      />
      <div className='pb-24 lg:pb-0 xl:pt-44'>
        <div className='container mx-auto space-y-8 px-4 lg:pt-44 xl:pt-0'>
          <TitleShadow
            prologue='คุณสมบัติที่สำคัญ'
            colorPrologue='rgba(0,0,0,.08)'
            title={
              <>
                LiFF มีประโยชน์กับธุรกิจ
                <br />
                ของคุณอย่างไร
              </>
            }
            colorTitle='#000000'
            align='center'
          />
          <div className='grid grid-cols-1 gap-8 lg:grid-cols-2'>
            <Benefit
              className='border-none text-content-base'
              title={<>ประสบการณ์ที่ดี</>}
              prologue='01'
              subtitle='LiFF ช่วยเพิ่ม'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <p>และสะดวกให้กับลูกค้าของคุณในการเข้าถึงเนื้อหาและ บริการต่างๆ ที่คุณมี</p>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <Benefit
              className='border-none text-content-base'
              title={<>โอกาสใหม่ ๆ</>}
              prologue='02'
              subtitle='LiFF ช่วยสร้าง'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <p>
                  ให้กับธุรกิจของคุณเป็นเครื่องมือส่งเสริมการตลาด
                  และเป็นช่องทางการขายที่สำคัญของธุรกิจ
                </p>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <div className='lg:col-span-2'>
              <ImgResponsive
                src='/images/service/middle_sevice_line_app.webp'
                alt='Twin Synergy service'
                sourceImgSm='/images/service/middle_sevice_line_app.webp'
                sourceImgMd='/images/service/middle_sevice_line_app.webp'
                loadingLazy
                className='mx-auto'
              />
            </div>
            <Benefit
              className='border-none text-content-base'
              title={<>ในการปิดการขาย</>}
              prologue='03'
              subtitle='LiFF ช่วยเพิ่มศักยภาพ'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={<p>และสามารถชำระเงินได้ไดง่าย</p>}
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <Benefit
              className='border-none text-content-base'
              title={<>การติดต่อ</>}
              prologue='04'
              subtitle='LiFF เป็นช่องทาง'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={<p>และสื่อสารกับลูกค้าที่มีประสิทธิภาพสูง</p>}
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <Benefit
              className='border-none text-content-base'
              title={<>และอัปเดตได้ง่าย</>}
              prologue='05'
              subtitle='LiFF สามารถปรับแต่ง'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={<p>ตามความต้องการของธุรกิจ</p>}
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <div className='px-4'>
              <h3 className='mb-16 text-3xl'>Experiences</h3>
              <div className=''>
                <ListBullet
                  list={[
                    'Loyalty Program on LINE OA',
                    'HR Management on LINE OA',
                    'Music Steaming App',
                    'Insurance on LINE OA',
                    'ETC.',
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-neutral py-28'>
        <div className='container mx-auto space-y-8 px-4'>
          <div className='grid grid-cols-1 items-center gap-4 text-white lg:grid-cols-2 xl:gap-8'>
            <ImgResponsive
              src='/images/service/service_contact.webp'
              alt='Twin Synergy service'
              sourceImgSm='/images/service/service_contact.webp'
              sourceImgMd='/images/service/service_contact.webp'
              loadingLazy
              className='mx-auto'
            />
            <div className='space-y-6'>
              <h2 className='xl:text-7xl'>
                ถ้าคุณคิดว่าการพัฒนา LiFF มันจะช่วยให้ Line Official Account
              </h2>
              <p className='font-bold xl:text-4xl'>
                ที่คุณมีอยู่แล้วมันเจ๋งขึ้น น่าสนใจมากขึ้นแล้วช่วย ให้ธุรกิจของคุณดีขึ้น
                ยอดขายเพิ่มขึ้น แล้วคุณจะ ต้องรออะไร ลุยเลย!!!
              </p>
              <p>
                แต่ก่อนที่คุณจะคุยกับใคร คุณลองคุยกับเราก่อน เรายินดีให้คำแนะนำ
                คำปรึกษากับคุณอย่างเต็มที่
              </p>
              <Button
                htmlType='button'
                className='btn-warning'
                onClick={() => Router.push('/contact')}
              >
                ปรึกษาทีมผู้เชี่ยวชาญ
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className='pt-24 lg:pt-44'>
        <div className='container mx-auto space-y-8 px-4 pb-14 xl:pt-0'>
          <TitleShadow
            prologue='ผลงาน'
            colorPrologue='rgba(0,0,0,.08)'
            title={<>ผลงานของเรา</>}
            colorTitle='#000000'
            align='center'
          />
        </div>
        <div className='grid grid-cols-2 lg:grid-cols-4'>
          <PortfolioItem
            title='Spicy Club'
            categories='Line liff'
            serviceImg='/images/service/liff/Spicy_Club.webp'
            serviceBg='#FFCA64'
          />
          <PortfolioItem
            title='Indorama'
            categories='Line liff'
            serviceImg='/images/service/liff/Indorama.webp'
            serviceBg='#FFCA64'
          />
          <PortfolioItem
            title='Krungthai'
            categories='Line liff'
            serviceImg='/images/service/liff/Krungthai.webp'
            serviceBg='#FFCA64'
          />
          <PortfolioItem
            title='OR Happy'
            categories='Line liff'
            serviceImg='/images/service/liff/OR_Happy.webp'
            serviceBg='#FFCA64'
          />
        </div>
        <div className='bg-neutral text-center'>
          <Link
            className='flex items-center justify-center py-4 font-light text-white'
            href='/portfolio'
          >
            ดูโปรเจกต์ทั้งหมด <FaArrowRight className='ml-2' size={14} />
          </Link>
        </div>
        <div className='warranty grid grid-cols-2 lg:grid-cols-5'>
          <WarrantyItem
            className='col-span-2 xl:col-span-1'
            content={
              <>
                Warrantee Source
                <br />
                code 1 year
              </>
            }
            serviceImg='/images/service/warratee.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Support team (8/7)
                <br />6 month
              </>
            }
            serviceImg='/images/service/support_team.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content='Free MA 6 month'
            serviceImg='/images/service/free_MA.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Free consultant
                <br />
                Forever
              </>
            }
            serviceImg='/images/service/free_consultant.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Free integration
                <br />
                service fee
              </>
            }
            serviceImg='/images/service/free_integration.webp'
            serviceBg='#F7F8F9'
          />
        </div>
      </div>
      <div className='bg-author-base py-24'>
        <div className='container mx-auto space-y-8'>
          <ServiceGetInTouch
            content='การสร้างโอกาสบนโลกออนไลน์ให้กับธุรกิจ เป็นสิ่งที่จำเป็นต้องทำในปัจจุบัน อย่าปล่อยให้เวลาผ่านไปโดยที่เราไม่ได้ทำอะไรเลย ติดต่อเราเพื่อสอบถาม
เพิ่มเติมและเริ่มต้นโปรเจคของคุณวันนี้!'
          />
        </div>
      </div>
      <div className='section-service pt-24 lg:pt-44'>
        <div className='container mx-auto space-y-8 px-4 pb-14 lg:pt-44 xl:pt-0'>
          <TitleShadow
            prologue='บริการ'
            colorPrologue='rgba(0,0,0,.08)'
            title='บริการอื่น ๆ'
            colorTitle='#000000'
            align='center'
          />
        </div>
        <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4'>
          <ServiceItem
            prologue='01'
            title='พัฒนาเว็บไซต์'
            serviceImg='/images/service/service-01.webp'
            serviceBg='#06B7B7'
            serviceUrl='website-development'
          />
          <ServiceItem
            prologue='02'
            title='พัฒนาแอปพลิเคชั่นมือถือ'
            serviceImg='/images/service/service-02.webp'
            serviceBg='#1990FF'
            serviceUrl='mobile-application-development'
          />
          <ServiceItem
            prologue='03'
            title='ออกแบบเว็บไซต์'
            serviceImg='/images/service/service-03.webp'
            serviceBg='#FFCA64'
            serviceUrl='website-design'
          />
          <ServiceItem
            prologue='04'
            title='เว็บไซต์สำหรับธุรกิจ SME'
            serviceImg='/images/service/service-04.webp'
            serviceBg='#FFAC79'
            serviceUrl='sme-website-development'
          />
          <ServiceItem
            prologue='05'
            title='ออกแบบและพัฒนา Line OA'
            serviceImg='/images/service/service-05.webp'
            serviceBg='#00BE00'
            serviceUrl='line-oa-development'
          />
          <ServiceItem
            prologue='06'
            title='พัฒนาซอฟต์แวร์ตามกำหนด'
            serviceImg='/images/service/service-06.webp'
            serviceBg='#FF7D7D'
            serviceUrl='custom-software-development'
          />
          <ServiceItem
            prologue='07'
            title='เพิ่มความปลอดภัย'
            serviceImg='/images/service/no-service.webp'
            serviceBg='#B577E5'
            noLink
          />
          <ServiceItem
            prologue='08'
            title='ดูแลบำรุงรักษาเว็บไซต์'
            serviceImg='/images/service/no-service.webp'
            serviceBg='#484848'
            noLink
          />
        </div>
      </div>
    </LayoutDefault>
  )
}

export default ServicePage
